import CodeMirror from 'codemirror';
import {customCompleteList} from './autocompleteList.js'


var orig = CodeMirror.hint.javascript;
CodeMirror.hint.javascript = function(cm,options) {
  var inner = orig(cm,options) || { from: cm.getCursor(), to: cm.getCursor(), list: [] };
  var cur = cm.getCursor();
  var token = cm.getTokenAt(cur);
  var currentWord = token.string;

  if (inner.list.length === 0 && (token.type === "property"|| token.string === '.')) {
   
    inner.list = customCompleteList.filter(item => token.string === '.' || item.text.startsWith(currentWord)).map(item => ({
      text: item.text,
      displayText: item.displayText,
      type: item.type
  }));
  }

  return inner;
};
















